import $ from 'jquery';

/**
 * Configures and attaches tooltips
 *
 * Usage:
 *
 *    const tooltipAttacher = new TooltipAttacher;
 *    tooltipAttacher.attach('trigger-tooltip');
 */
export default class TooltipAttacher {
	constructor() {
		this.rtlEnabled = () => $('html').attr('dir') === 'rtl';
	}

	attachTooltips(element) {
		const defaultContainer = this.rtlEnabled() ? false : 'body';

		const container = element.data('container') !== undefined ? element.data('container') : defaultContainer;
		const placement = element.data('placement') || 'top';
		const triggerEvent = element.data('trigger') || 'click';
		const hideEvent = element.data('hide');

		const options = {
			trigger: triggerEvent,
			container: container,
			placement: placement,
		};

		element.popover(options);

		if (hideEvent) {
			element.on(hideEvent, function () {
				$(this).popover('hide');
			});
		}
	}

	attach(elements) {
		const $elements = $(`.${elements}`);
		$elements.each((index, el) => {
			this.attachTooltips($(el));
		});
	}

	hide(elements, target) {
		const $elements = $(`.${elements}`);
		$elements.each(function () {
			if (!$(this).is(target) && $(this).has(target).length === 0 && $('.popover').has(target).length === 0) {
				$(this).popover('hide');
			}
		});
	}
}
